import React, { FC } from 'react'
import { Link, useLocation } from 'react-router-dom'

import { Icon, IconColor, IconName, IconStack } from 'Components/Icon'

export type NavigationItem = {
  icon: IconName
  label: string
  target: string
  external?: boolean
}

const isActiveTarget = (currentUrl: string, target: string): boolean => {
  return currentUrl === target
}

type SidebarNavigationProps = {
  navigationItems: NavigationItem[]
  activeTarget?: string
  onItemClick?: (target: string) => void
}

const SidebarNavigation: FC<SidebarNavigationProps> = ({ navigationItems, activeTarget, onItemClick }) => {
  const currentUrl = useLocation().pathname

  return (
    <nav className="sidebar-menu" aria-label="Ansicht wechseln">
      {navigationItems.map(({ icon, label, target, external }) => {
        const isActive = !external && (onItemClick ? activeTarget === target : isActiveTarget(currentUrl, target))

        const className = `sidebar-menu-item ${isActive ? 'is-active' : ''}`

        if (onItemClick) {
          const handleClick = onItemClick

          return (
            <button key={target} type="button" className={className} onClick={() => handleClick(target)}>
              <IconStack
                inactiveName={icon}
                inactiveColor={IconColor.GRAY_1}
                activeName={icon}
                activeColor={IconColor.BLUE_2}
                isActive={isActive}
              />

              <span>{label}</span>
            </button>
          )
        }

        if (external) {
          return (
            <a key={target} href={target} className={className}>
              <Icon name={icon} color={IconColor.GRAY_1} />

              <span>{label}</span>
            </a>
          )
        }

        return (
          <Link key={target} to={target} className={className}>
            <IconStack
              inactiveName={icon}
              inactiveColor={IconColor.GRAY_1}
              activeName={icon}
              activeColor={IconColor.BLUE_2}
              isActive={isActive}
            />

            <span>{label}</span>
          </Link>
        )
      })}
    </nav>
  )
}

export default SidebarNavigation
